import sharedConfig from '../sharedConfig';

export const ZRM_DEV_BRAND = 'dev_brand';
export const HOST_APP = 'hostApp';
export const ZRM_API = 'ZRM_API';

// FEATURE_FLAGS
export const ZRM_RENT_GUARANTEE_ENABLED = 'ZRM_RENT_GUARANTEE_ENABLED';
export const ZRM_RENTERS_INSURANCE_FORM_FIELD_ENABLED = 'ZRM_RENTERS_INSURANCE_FORM_FIELD_ENABLED';
export const ZRM_MODULAR_LISTING_ENABLED = 'ZRM_MODULAR_LISTING_ENABLED';
export const ZRM_MODULAR_LISTING_ROOM_FOR_RENT = 'ZRM_MODULAR_LISTING_ROOM_FOR_RENT';
export const ZRM_MULTIPLEX_ENABLED = 'ZRM_MULTIPLEX_ENABLED';
export const ZRM_EDIT_MF_FEED_CONTACT_ENABLED = 'ZRM_EDIT_MF_FEED_CONTACT_ENABLED';
export const ZRM_FEATURE_NOTIFICATION_ENABLED = 'ZRM_FEATURE_NOTIFICATION_ENABLED';
export const ZRM_USE_FREEMIUM_TEST_DATA = 'ZRM_USE_FREEMIUM_TEST_DATA';
export const ZRM_ONBOARDING_WIZARD_ENABLED = 'ZRM_ONBOARDING_WIZARD_ENABLED';
export const ZRM_MAINTENANCE_TRACKER = 'ZRM_MAINTENANCE_TRACKER';
export const ZRM_USE_UPLIFT_BRAIN_TEST_DATA = 'ZRM_USE_UPLIFT_BRAIN_TEST_DATA';
export const ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED = 'ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED';
export const ZRM_MARKETING_COMPONENTS_ENABLED = 'ZRM_MARKETING_COMPONENTS_ENABLED';
export const ZRM_LEGACY_TOUR_DISABLED = 'ZRM_LEGACY_TOUR_DISABLED';
export const ZRM_TENANTS_MODULE_ENABLED = 'ZRM_TENANTS_MODULE_ENABLED';
export const ZRM_LISTING_QUALITY_ENABLED = 'ZRM_LISTING_QUALITY_ENABLED';
export const ZRM_POSTING_PATH_TOUR_SCHEDULING_ENABLED = 'ZRM_POSTING_PATH_TOUR_SCHEDULING_ENABLED';
export const ZRM_DESCRIPTION_REORDER_ENABLED = 'ZRM_DESCRIPTION_REORDER_ENABLED';
export const ZRM_TOTAL_MONTHLY_PRICE_ENABLED = 'ZRM_TOTAL_MONTHLY_PRICE_ENABLED';
export const ZRM_AUTH_0_ENABLED = 'ZRM_AUTH_0_ENABLED';

// DEVTOOLS
export const ZRM_REACT_QUERY_DEVTOOLS = 'ZRM_REACT_QUERY_DEVTOOLS';
export const ZRM_REDUX_DEVTOOLS = 'ZRM_REDUX_DEVTOOLS';
export const ZRM_ENABLE_GA = 'ZRM_ENABLE_GA';
export const ZRM_DEVTOOLS_ENABLED = 'ZRM_DEVTOOLS_ENABLED';

export const ZRM_MOCK_USER_ENABLED = 'ZRM_MOCK_USER_ENABLED';
export const ZRM_MOCK_USER_EMAIL = 'ZRM_MOCK_USER_EMAIL';
export const ZRM_MOCK_USER_IMPERSONATOR_TOKEN = 'ZRM_MOCK_USER_IMPERSONATOR_TOKEN';
export const ZRM_MOCK_USER_IMPERSONATOR_EMAIL = 'ZRM_MOCK_USER_IMPERSONATOR_EMAIL';

export const ZRM_MOCK_USERS_GENERATE_NEW_EMAIL = 'xxxxxxxxxx@zillow.com';

export const ZRM_MOCK_USERS = [
  {
    email: ZRM_MOCK_USERS_GENERATE_NEW_EMAIL,
    comment: 'Generate a new user',
  },
  {
    email: 'mockeduser@zillow.com',
    comment: 'Default mock user',
  },
  {
    email: 'rocket_ship_user@zillow.com',
    comment: 'Single family feed listings',
  },
  {
    email: 'mfh_rocket_ship_user@zillow.com',
    comment: 'Multifamily feed listings',
  },
  {
    email: 'mfh_user@zillow.com',
    comment: 'Multifamily customer',
  },
  {
    email: 'company_admin@zillow.com',
    comment: 'Company admin for user management',
  },
  {
    email: 'nucleus_user@zillow.com',
    comment: 'Single family paid inclusion',
  },
  {
    email: 'single_family_legacy@zillow.com',
    comment: 'Old single family legacy user',
  },
  {
    email: 'flat_fee_rocket_ship_user@zillow.com',
    comment: 'Single family with flat fee product',
  },
  {
    email: 'rentalrevenueplatform@zillow.com',
    comment: 'To test multifamily packages',
  },
];

const FeatureFlagConstants = {
  // features
  [ZRM_RENT_GUARANTEE_ENABLED]: false,
  [ZRM_RENTERS_INSURANCE_FORM_FIELD_ENABLED]: false,
  [ZRM_MODULAR_LISTING_ENABLED]: false,
  [ZRM_MODULAR_LISTING_ROOM_FOR_RENT]: false,
  [ZRM_MULTIPLEX_ENABLED]: false,
  [ZRM_EDIT_MF_FEED_CONTACT_ENABLED]: false,
  [ZRM_FEATURE_NOTIFICATION_ENABLED]: false,
  [ZRM_USE_FREEMIUM_TEST_DATA]: false,
  [ZRM_ONBOARDING_WIZARD_ENABLED]: false,
  [ZRM_MAINTENANCE_TRACKER]: false,
  [ZRM_USE_UPLIFT_BRAIN_TEST_DATA]: false,
  [ZRM_MULTI_BOX_VERIFICATION_INPUT_ENABLED]: false,
  [ZRM_MARKETING_COMPONENTS_ENABLED]: false,
  [ZRM_LEGACY_TOUR_DISABLED]: false,
  [ZRM_TENANTS_MODULE_ENABLED]: false,
  [ZRM_LISTING_QUALITY_ENABLED]: false,
  [ZRM_POSTING_PATH_TOUR_SCHEDULING_ENABLED]: false,
  [ZRM_DESCRIPTION_REORDER_ENABLED]: false,
  [ZRM_TOTAL_MONTHLY_PRICE_ENABLED]: false,
  [ZRM_AUTH_0_ENABLED]: false,

  // DEVTOOLS
  [ZRM_REACT_QUERY_DEVTOOLS]: false,
  [ZRM_REDUX_DEVTOOLS]: false,
  [ZRM_ENABLE_GA]: false,
  [ZRM_DEVTOOLS_ENABLED]: false,

  // mocked user is only auto enabled for the sherman environment
  [ZRM_MOCK_USER_ENABLED]: false,
  [ZRM_MOCK_USER_EMAIL]: '',
  [ZRM_MOCK_USER_IMPERSONATOR_TOKEN]: '',
  [ZRM_MOCK_USER_IMPERSONATOR_EMAIL]: '',

  // TODO: move those non-boolean values out since they're not
  // strictly features.
  [HOST_APP]: 'none',
  [ZRM_DEV_BRAND]: sharedConfig.defaultBrand,
  [ZRM_API]: sharedConfig.defaultZgApi,
};

export default FeatureFlagConstants;
